import styled, { css } from "styled-components";

const baseButtonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: 42px;
  min-height: 42px;
  text-decoration: none;
  background-color: rgb(255, 96, 48);
  padding: 9px 20px;
  border-radius: 12px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  color: #ffffff;
  border: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  z-index: 0;

  &:hover {
    background:
      linear-gradient(0deg, rgba(255, 96, 48, 0.85), rgba(255, 96, 48, 0.85)),
      #ffffff;
  }

  /* Blur effect */
  &::before {
    content: "";
    position: absolute;
    left: 8.81%;
    right: 8.81%;
    height: 18px;
    background-color: #ffab95;
    filter: blur(16px);
    border-radius: 59px;
    z-index: -1;
  }

  ${({ $variant }) =>
    $variant === "header" &&
    css`
      /* Blur effect */
      &::before {
        top: 32.26px;
      }
    `}

  ${({ $variant }) =>
    $variant === "subMenu" &&
    css`
      width: 100%;
      max-width: 298px;
      margin: 0 auto;

      /* Blur effect */
      &::before {
        top: 38.26px;
      }
    `}
`;

export const Button = styled.button`
  ${baseButtonStyles}
`;

export const LinkButton = styled.a`
  ${baseButtonStyles}
`;

export const Icon = styled.img`
  margin-left: 8px;
  height: 20px;
  width: 20px;

  ${({ $variant }) =>
    $variant === "header" &&
    css`
      @media ${({ theme }) => theme.media.mobile} {
        display: none;
      }
    `}

  ${({ $variant }) => $variant === "subMenu" && css``}
`;
